<template>
  <BarcodeCreator />
</template>
<script>
import BarcodeCreator from "@/components/Admin/BarcodeCreator.vue";

export default {
  name: "BarcodeLabels",
  components: { BarcodeCreator }
};
</script>

<style scoped></style>